"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var Lock = function Lock(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.3398 7.08H14.5798V4.58C14.5798 2.05083 12.529 0 9.99984 0C7.47068 0 5.41984 2.05083 5.41984 4.58V7.08H1.65984C1.20484 7.09083 0.839844 7.4625 0.839844 7.92V15.84C0.839844 18.1375 2.70234 20 4.99984 20H14.9998C17.2973 20 19.1598 18.1375 19.1598 15.84V7.92C19.1598 7.46333 18.7948 7.09167 18.3407 7.08H18.3398V7.08ZM7.07984 4.58C7.07984 2.9675 8.38734 1.66 9.99984 1.66C11.6123 1.66 12.9198 2.9675 12.9198 4.58V7.08H7.07984V4.58ZM17.4998 15.84C17.4998 17.2208 16.3807 18.34 14.9998 18.34H4.99984C3.61901 18.34 2.49984 17.2208 2.49984 15.84V8.74H17.4998V15.84Z"
  }));
};
var _default = exports["default"] = Lock;